import { IdFmt } from "../utils/id";
export const userIdFmt = new IdFmt("AGU", 2, 4);
export const boIdFmt = new IdFmt("AGP", 2, 4);
export const pbIdFmt = new IdFmt("AGL", 2, 4);
export const shipmentIdFmt = new IdFmt("AGS", 2, 4);
export const targetIdFmt = new IdFmt("AGT", 2, 4);
export const balanceAdjustmentIdFmt = new IdFmt("AGB", 2, 4);
export const marketplaceBookingIdFmt = new IdFmt("AGMB", 2, 4);
export const equipmentCategoryIdFmt = new IdFmt("AGEC", 2, 4);
export const equipmentModelIdFmt = new IdFmt("AGEM", 2, 4);
export const equipmentMachineIdFmt = new IdFmt("AGEMA", 2, 4);
export const equipmentBookingIdFmt = new IdFmt("AGEB", 2, 4);
export const soilTestingBookingIdFmt = new IdFmt("AGST", 2, 4);
export const reimbursementRequestIdFmt = new IdFmt("AGR", 2, 4);
const ID_FORMAT_REGISTRY = [
    // 5-character prefixes
    { prefix: "AGEMA", fmt: equipmentMachineIdFmt, type: "EQUIPMENT_MACHINE" },
    // 4-character prefixes
    {
        prefix: "AGMB",
        fmt: marketplaceBookingIdFmt,
        type: "MARKETPLACE_BOOKING",
    },
    { prefix: "AGEC", fmt: equipmentCategoryIdFmt, type: "EQUIPMENT_CATEGORY" },
    { prefix: "AGEM", fmt: equipmentModelIdFmt, type: "EQUIPMENT_MODEL" },
    { prefix: "AGEB", fmt: equipmentBookingIdFmt, type: "EQUIPMENT_BOOKING" },
    {
        prefix: "AGST",
        fmt: soilTestingBookingIdFmt,
        type: "SOIL_TESTING_BOOKING",
    },
    // 3-character prefixes
    { prefix: "AGU", fmt: userIdFmt, type: "USER" },
    { prefix: "AGP", fmt: boIdFmt, type: "OUTPUT_BUYER" },
    { prefix: "AGL", fmt: pbIdFmt, type: "OUTPUT_SELLER" },
    { prefix: "AGS", fmt: shipmentIdFmt, type: "SHIPMENT" },
    { prefix: "AGT", fmt: targetIdFmt, type: "TARGET" },
    { prefix: "AGB", fmt: balanceAdjustmentIdFmt, type: "BALANCE_ADJUSTMENT" },
    {
        prefix: "AGR",
        fmt: reimbursementRequestIdFmt,
        type: "REIMBURSEMENT_REQUEST",
    },
];
export function parsePubId(id) {
    const cleanId = id.toUpperCase();
    // Scan sequentially. AGST will be checked and matched before AGS is ever reached.
    const match = ID_FORMAT_REGISTRY.find(item => cleanId.startsWith(item.prefix));
    if (!match)
        return undefined;
    return { type: match.type, fmt: match.fmt };
}
//# sourceMappingURL=ids.js.map